// extracted by mini-css-extract-plugin
export var slideFrame = "slider-frame-module--slideFrame--ee2d8";